import React from 'react'
import maplibregl from 'maplibre-gl'
import { useGlobalState } from 'state'
import { IDs } from 'common/consts'
import { TimeSeriesRow } from 'common/types'

type RainTileLayerProps = {
  code: string
  bounds: maplibregl.LngLatBounds
  rain: TimeSeriesRow | null
  opacity: number
}

export const KouzuiKikikuruTileLayer = ({code, bounds, rain, opacity}: RainTileLayerProps) => {
  const state = useGlobalState()
  const sourceId = `${IDs.rainfall.tileSource}-${code}`
  const layerId = `${IDs.rainfall.tileLayer}-${code}`

  const load = () => {
    if (!rain || rain.tileUrl === undefined) {
      remove()
      return
    }

    const url = rain.tileUrl.replace('{code}', code)
    const coordinates = [
      [bounds.getWest(), bounds.getNorth()],
      [bounds.getEast(), bounds.getNorth()],
      [bounds.getEast(), bounds.getSouth()],
      [bounds.getWest(), bounds.getSouth()]
    ]
    if (state.map.hasSource(sourceId)) {
      state.map.updateImageSource(sourceId, url)
    } else {
      state.map.addSource(sourceId, {
        'type': 'image',
        'url': url,
        'coordinates': coordinates
      })
    }

    state.map.addLayer({
      id: layerId,
      'type': 'raster',
      'source': sourceId,
      minzoom: 3,
      'paint': {
        'raster-resampling': 'nearest',
        'raster-opacity': opacity,
        'raster-fade-duration': 0
      },
    })
  }

  React.useEffect(() => {
    if (!state.mapbox) return
    if (!state.mapbox.getLayer(layerId)) return
    state.mapbox.setPaintProperty(
      layerId,
      'raster-opacity',
      opacity
    )
  }, [opacity])

  const remove = () => {
    state.map.removeLayer(layerId)
    state.map.removeSource(sourceId)
  }

  React.useEffect(() => {
    load()
  }, [rain])

  React.useEffect(() => {
    return () => {
      remove()
    }
  }, [])

  React.useEffect(() => {
    state.mapbox?.on('style.load', load)
    return () => {
      state.mapbox?.off('style.load', load)
    }
  }, [load])

  return (
    <></>
  )
}
